import { format } from "date-fns";

export const formatDateForDisplay = (date: Date | string | null): string => {
  if (!date) return "";

  try {
    const dateObj = typeof date === "string" ? new Date(date) : date;
    if (isNaN(dateObj.getTime())) {
      return "";
    }
    return format(dateObj, "MM/dd/yyyy");
  } catch {
    return "";
  }
};
